import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ADMIN_ROUTE_NAME } from '../constants/RouteName';
import { STORAGE } from '../constants/Storage';

export const languageData = [
  {
    languageId: 'japanese',
    locale: 'ja',
    name: '日本',
    icon: 'ja',
  },
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
];

export interface ILocaleState {
  languageId: string;
  locale: string;
  name: string;
  icon: string;
}

export interface SettingState {
  locale: ILocaleState;
  initAdminURL: string;
  logo: string | null;
}

const initialState: SettingState = {
  locale: languageData[0],
  initAdminURL: `/${ADMIN_ROUTE_NAME.STAFF_MANAGEMENT}`,
  logo: 'images/mos-main.png',
};

const settingSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    switchLanguage: (state, action: PayloadAction<ILocaleState>) => {
      state.locale = action.payload;
      localStorage.setItem(STORAGE.LOCALE, action.payload.locale);
    },
    setInitAdminUrl: (state, action: PayloadAction<string>) => {
      state.initAdminURL = action.payload;
    },
    updateLogo: (state, action: PayloadAction<string>) => {
      state.logo = action.payload || 'images/mos-main.png';

      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      if (link && link instanceof HTMLLinkElement) {
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = action.payload || 'images/mos-main.png';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    },
  },
});

export const { switchLanguage, setInitAdminUrl, updateLogo } = settingSlice.actions;

export default settingSlice.reducer;
